import React from "react"
import { Header } from "src/components/layout/header"
import { AuthRequestsPage } from "src/pages-lib/auth-requests/auth-requests-page"

// Журнал запросов на авторизацию по номеру: способы входа, каскад МТС ID, сводка.
export default function AuthRequests() {
  return (
    <>
      <Header title="Авторизации" />
      <AuthRequestsPage />
    </>
  )
}
